import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useSignOut from "react-auth-kit/hooks/useSignOut";

// Drop-in replacement for `fetch()`. On a 401 (expired/invalid JWT) it signs
// the user out and redirects to /Login instead of leaving the caller to fail
// silently or show a confusing generic error with no explanation.
//
// Migration note: only wired into a few pages so far (see SOLUTIONS.md) —
// most pages still call `fetch` directly and won't redirect on session expiry
// yet. Swap `fetch(url, opts)` for `apiFetch(url, opts)` in a component using
// `const apiFetch = useApiFetch();` to opt a page in.
export function useApiFetch() {
    const signOut = useSignOut();
    const navigate = useNavigate();

    return useCallback(
        async (input, init) => {
            const response = await fetch(input, init);
            if (response.status === 401) {
                signOut();
                navigate("/Login");
            }
            return response;
        },
        [signOut, navigate],
    );
}
